//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
let d=[[[0,"Associative",1,0],[0,"AssociativityType",1,0],[0,"EmbedWorksheet",1,0],[0,"EmbeddedWorksheet",1,0],[0,"FileBrowser",1,0],[0,"Inputs",1,0],[0,"Location",1,0],[0,"NativeFileBrowser",1,0],[0,"ShowInformationWindow",1,0],[0,"Worksheet",1,0]],[[["num_expressions"],"GetExpressions",{R_:{expressions:"Expression[]"}},0,0],[["expressions"],"SetExpressions",{},1,0],[["num_names"],"GetMathNames",{R_:{names:""}},0,0],[["names"],"SetMathNames",{},1,0]],[]];
SPLM.Features.MathIntegrationBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.MathIntegrationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.MathIntegrationBuilder.LocationTypes = Object.freeze({
    "OperatingSystem" : "OperatingSystem", "Teamcenter" : "Teamcenter", "Embedded" : "Embedded"});

SPLM.Features.MathIntegrationBuilder.AssociativityTypes = Object.freeze({
    "None" : "None", "New" : "New", "Existing" : "Existing"});

export default SPLM;